const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: 1.5,
    p: 3,
    border: "1.5px solid",
    borderColor: "grey.200",
    borderRadius: 3,
    bgcolor: "white",
    cursor: "pointer",
    transition: "all 0.15s ease",
  },
  iconContainer: {
    width: 52,
    height: 52,
    borderRadius: "50%",
    border: "1.5px solid",
    borderColor: "grey.300",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  brandNameInitialContainer: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    border: "1px solid",
    borderColor: "grey.300",
    bgcolor: "grey.200",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoUrl: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    objectFit: "cover",
    border: "1px solid",
    borderColor: "grey.300",
    bgcolor: "white",
  },
};

export default styles;
